import request from '../utils'

const lifeCycleApi = {
    lifeCycleList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/lifeCycle`)
        const res = await req;
        return res.body;
    }, 
    lifeCycleDetail: async (modelingId, lifeCycle) => {
        const req = request.get(`/api/modeling/${modelingId}/lifeCycle/${lifeCycle}`)
        const res = await req;
        return res.body;
    },
    lifeCycleUpdate: async (modelingId, lifeCycle) => {
        const req = request.put(`/api/modeling/${modelingId}/lifeCycle/${lifeCycle.id}`).send(lifeCycle);
        const res = await req;
        return res.body;
    },
    lifeCycleCreate: async (modelingId, lifeCycle) => {
        const req = request.post(`/api/modeling/${modelingId}/lifeCycle`).send(lifeCycle);
        const res = await req;
        return res.body;
    },
    lifeCycleDelete: async (modelingId, lifeCycleId) => {
        const req = request.delete(`/api/modeling/${modelingId}/lifeCycle/${lifeCycleId}`);
        await req;
    }
};

export default lifeCycleApi